const ActiveYearsIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <g transform="translate(-63.156 -63.156)">
        <path
          d="M79.52,63.156H64.793a1.636,1.636,0,0,0-1.637,1.637V79.52a1.635,1.635,0,0,0,1.637,1.636H79.52a1.635,1.635,0,0,0,1.636-1.636V64.793A1.635,1.635,0,0,0,79.52,63.156Zm-3.512,9.578L71.46,77.283a.818.818,0,0,1-1.157,0L68.3,75.276a.818.818,0,0,1,1.157-1.157l1.429,1.429,3.969-3.969a.818.818,0,0,1,1.157,1.157Zm3.512-4.669H64.793V64.793H79.52Z"
          transform="translate(0 0)"
          fill="#075da9"
        />
      </g>
    </svg>
  );
};

export default ActiveYearsIcon;
